"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONNumberingListExporter = void 0;
var common_1 = require("@devexpress/utils/lib/utils/common");
var json_list_enums_1 = require("../enums/json-list-enums");
var JSONNumberingListExporter = (function () {
    function JSONNumberingListExporter() {
    }
    JSONNumberingListExporter.exportAbstractNumberingLists = function (documentModel) {
        var listLevelPropertiesCache = documentModel.cache.listLevelPropertiesCache;
        var maskedCharacterPropertiesCache = documentModel.cache.maskedCharacterPropertiesCache;
        var maskedParagraphPropertiesCache = documentModel.cache.maskedParagraphPropertiesCache;
        var jsonAbstractNumberingLists = [];
        for (var _i = 0, _a = documentModel.abstractNumberingLists; _i < _a.length; _i++) {
            var abstractNumberingList = _a[_i];
            var jsonAbstractNumberingList = {};
            jsonAbstractNumberingList[json_list_enums_1.JSONAbstractNumberingListProperty.Deleted] = common_1.boolToInt(abstractNumberingList.deleted);
            jsonAbstractNumberingList[json_list_enums_1.JSONAbstractNumberingListProperty.Id] = abstractNumberingList.innerId;
            var jsonLevels = [];
            for (var _b = 0, _c = abstractNumberingList.levels; _b < _c.length; _b++) {
                var level = _c[_b];
                var jsonLevel = {};
                jsonLevel[json_list_enums_1.JSONNumberingListLevelProperty.CharacterPropertiesIndex] =
                    maskedCharacterPropertiesCache.indexOf(level.getCharacterProperties());
                jsonLevel[json_list_enums_1.JSONNumberingListLevelProperty.ParagraphPropertiesIndex] =
                    maskedParagraphPropertiesCache.indexOf(level.getParagraphProperties());
                jsonLevel[json_list_enums_1.JSONNumberingListLevelProperty.ListLevelPropertiesIndex] =
                    listLevelPropertiesCache.indexOf(level.getListLevelProperties());
                jsonLevels.push(jsonLevel);
            }
            jsonAbstractNumberingList[json_list_enums_1.JSONAbstractNumberingListProperty.Levels] = jsonLevels;
            jsonAbstractNumberingLists.push(jsonAbstractNumberingList);
        }
        return jsonAbstractNumberingLists;
    };
    JSONNumberingListExporter.exportNumberingLists = function (documentModel) {
        var listLevelPropertiesCache = documentModel.cache.listLevelPropertiesCache;
        var maskedCharacterPropertiesCache = documentModel.cache.maskedCharacterPropertiesCache;
        var maskedParagraphPropertiesCache = documentModel.cache.maskedParagraphPropertiesCache;
        var jsonNumberingLists = [];
        for (var _i = 0, _a = documentModel.numberingLists; _i < _a.length; _i++) {
            var numberingList = _a[_i];
            var jsonNumberingList = {};
            jsonNumberingList[json_list_enums_1.JSONNumberingListProperty.AlIndex] = numberingList.abstractNumberingListIndex;
            jsonNumberingList[json_list_enums_1.JSONNumberingListProperty.Id] = numberingList.innerId;
            var jsonLevels = [];
            for (var _b = 0, _c = numberingList.levels; _b < _c.length; _b++) {
                var level = _c[_b];
                var jsonLevel = {};
                jsonLevel[json_list_enums_1.JSONNumberingListLevelProperty.CharacterPropertiesIndex] =
                    maskedCharacterPropertiesCache.indexOf(level.getCharacterProperties());
                jsonLevel[json_list_enums_1.JSONNumberingListLevelProperty.ParagraphPropertiesIndex] =
                    maskedParagraphPropertiesCache.indexOf(level.getParagraphProperties());
                jsonLevel[json_list_enums_1.JSONNumberingListLevelProperty.ListLevelPropertiesIndex] =
                    listLevelPropertiesCache.indexOf(level.getListLevelProperties());
                jsonLevels.push(jsonLevel);
            }
            jsonNumberingList[json_list_enums_1.JSONNumberingListProperty.Levels] = jsonLevels;
            jsonNumberingLists.push(jsonNumberingList);
        }
        return jsonNumberingLists;
    };
    JSONNumberingListExporter.exportAbstractNumberingListTemplates = function (documentModel) {
        var listLevelPropertiesCache = documentModel.cache.listLevelPropertiesCache;
        var maskedCharacterPropertiesCache = documentModel.cache.maskedCharacterPropertiesCache;
        var maskedParagraphPropertiesCache = documentModel.cache.maskedParagraphPropertiesCache;
        var jsonAbstractNumberingListTemplates = [];
        for (var _i = 0, _a = documentModel.abstractNumberingListTemplates; _i < _a.length; _i++) {
            var abstractNumberingListTemplate = _a[_i];
            var jsonAbstractNumberingListTemplate = {};
            jsonAbstractNumberingListTemplate[json_list_enums_1.JSONAbstractNumberingListProperty.Deleted] = common_1.boolToInt(abstractNumberingListTemplate.deleted);
            jsonAbstractNumberingListTemplate[json_list_enums_1.JSONAbstractNumberingListProperty.Id] = abstractNumberingListTemplate.innerId;
            var jsonLevels = [];
            for (var _b = 0, _c = abstractNumberingListTemplate.levels; _b < _c.length; _b++) {
                var level = _c[_b];
                var jsonLevel = {};
                jsonLevel[json_list_enums_1.JSONNumberingListLevelProperty.CharacterPropertiesIndex] =
                    maskedCharacterPropertiesCache.indexOf(level.getCharacterProperties());
                jsonLevel[json_list_enums_1.JSONNumberingListLevelProperty.ParagraphPropertiesIndex] =
                    maskedParagraphPropertiesCache.indexOf(level.getParagraphProperties());
                jsonLevel[json_list_enums_1.JSONNumberingListLevelProperty.ListLevelPropertiesIndex] =
                    listLevelPropertiesCache.indexOf(level.getListLevelProperties());
                jsonLevels.push(jsonLevel);
            }
            jsonAbstractNumberingListTemplate[json_list_enums_1.JSONAbstractNumberingListProperty.Levels] = jsonLevels;
            jsonAbstractNumberingListTemplates.push(jsonAbstractNumberingListTemplate);
        }
        return jsonAbstractNumberingListTemplates;
    };
    return JSONNumberingListExporter;
}());
exports.JSONNumberingListExporter = JSONNumberingListExporter;
